import Swal from "sweetalert2"
import { Tooltip as ReactTooltip } from "react-tooltip";
import { lifecycleSuggestions } from "../../utility/lifeCycleSuggestions"

const RetailerLeaderboardTrend = ({ trend, setSearchParams, searchParams, trendsData, page, index, setSelectedTagValue, userLoggedIn, bgColor, isMyntra, indexOffset = 0 }) => {

  return <div key={`${trend._id.tag}_${trend._id.value}`} className="flex h-28 my-1 overflow-x-hidden">
    <div className="shrink-0 w-36 lg:w-40 h-full  relative">
      <div className={`w-full h-full overflow-hidden hover:z-40 hover:h-auto hover:absolute ${bgColor}`}>
        <h3 className="font-semibold text-blue-600 hover:text-blue-500 "
          data-tooltip-id={`retailer-breakdown-${trend.tagFirst.tag}-${trend.tagFirst.value}` || `breakdown-${index}`}
          onClick={() => {
            Swal.fire({ title: `Browsing different ways to do ${searchParams.get('gender')} > ${searchParams.get('category')} > ${trend.tagFirst.tag} > ${trend.tagFirst.value}.` })
            setSearchParams(prev => {
              prev.set('tag', trendsData.tag)
              prev.set('value', trend.tagFirst.value)
              return prev
            })
          }}>{isMyntra ? (indexOffset + 1 + index) : (index + 1 + (page - 1) * 5)}. {trend.tagFirst.value != '#N/A' ? trend.tagFirst.value : 'No Specific'}</h3>

        {false && userLoggedIn && userLoggedIn.curator && searchParams.get('gender') == 'Female' ? <p className="text-[11px] font-semibold"><span>Rate Of Growth:</span> {trend.rateOfGrowth != 0 ? parseInt(trend.rateOfGrowth * 1000) / 10 : '0'}<span>%{trend.rogState ? <span>({trend.rogState})</span> : null}</span></p> : null}
        <p className="text-[11px]">Depth : {parseInt(trend.depth * 1000) / 10}%{trend.DepthState ? <span>({trend.DepthState})</span> : null}</p>

      </div>
    </div>
    <div className="h-full px-1">
      <div className="flex h-full overflow-x-hidden " onClick={() => setSelectedTagValue({ tag: trend.tagFirst.tag, value: trend.tagFirst.value, trendType: 'retailer' })}>
        {
          trend.products ? trend.products.map(image => <img src={image.imageUrl} className="h-full w-auto ml-1 border-[0.5px] min-w-14" />) : null
        }
      </div>
    </div>
    <div className="text-[10px] z-[90]">
      <ReactTooltip
        id={`retailer-breakdown-${trend.tagFirst.tag}-${trend.tagFirst.value}` || `breakdown-${index}`}

      >Breakdown {trend.tagFirst.value != '#N/A' ? trend.tagFirst.value : 'No Specific'}({trend.tagFirst.tag})</ReactTooltip>

    </div>
  </div>
}

export default RetailerLeaderboardTrend
